import { useAuthStore } from '@/store/auth'
import { isElectron } from '@/utils/isElectron'
import { loadImage } from '@/utils/load-image'

import type { PrinterDriver } from '../types'

export default class Browser implements PrinterDriver {
  constructor() {}

  async printImage(imageData: string) {
    const auth = useAuthStore()
    const locationId = auth.locationId
    const demoLocationId = import.meta.env.VITE_APP_DEMO_LOCATION_ID
    const isDemoLocation = locationId === demoLocationId

    if (isDemoLocation) return

    if (!isElectron) {
      const image = await loadImage(imageData)
      const w = window.open('')
      w?.document.write(image.outerHTML)
    }
  }

  openCashDrawer() {
    // Not supported in browser
  }
}
